module.exports = ng.material.progressBar;